export enum EOfferFormatKey {
  PRODUCTS = 'products',
  BALANCE = 'balance',
  SPECIAL_OFFER = 'specialOffer',
  ROLLING_OFFER = 'rollingOffer',
  PROGRESS_BAR = 'progressBar',
  TRIGGERED_POPUP = 'triggeredPopup'
}

export enum EQuantityFieldControl {
  SEPARATOR = 'separator',
  BOOLEAN = 'boolean',
  NUMBER = 'number'
}

export enum ETimeBaseUnit {
  DAYS = 'days',
  HOURS = 'hours',
  MINUTES = 'minutes',
  SECONDS = 'seconds'
}

export enum ETimeAbbreviationStyle {
  LETTER = 'letter',
  SHORT = 'short',
  LONG = 'long'
}

export interface ITimeFormat {
  baseUnitThreshold: number;
  baseUnit: ETimeBaseUnit;
  abbreviationStyle: ETimeAbbreviationStyle;
}

export interface IQuantityFormat {
  milSeparator: string;
  fractionalSeparator: string;
  thousandShorthand: boolean;
  millionShorthand: boolean;
  billionShorthand: boolean;
  trillionShorthand: boolean;
  quadrillionShorthand: boolean;
  quintillionShorthand: boolean;
  sextillionShorthand: boolean;
  septillionShorthand: boolean;
  digitsBasedAbbreviation: boolean;
  maxDigitsWithoutShorthand: number;
}

export interface INumberFormatEntry {
  quantity: IQuantityFormat;
  time: ITimeFormat;
}

export type INumberFormat = Record<EOfferFormatKey, INumberFormatEntry>;

export interface IStoreSettingsFormValues {
  numberFormat: INumberFormat;
}

export interface IQuantityFieldDescriptor {
  key: keyof IQuantityFormat;
  header: string;
  control: EQuantityFieldControl;
  gridSize: number;
}

export interface IQuantityFormatSection {
  key: EOfferFormatKey;
  title: string;
}
